import { ComponentBase } from "../core/ComponentBase.js";

export class DelegationCard extends ComponentBase {
    static styles = `
        .delegation-card {
            background-color: var(--bs-body-bg);
            border: 1px solid var(--bs-primary-border-subtle);
            border-left: 4px solid var(--bs-primary);
            border-radius: var(--ab-radius-md);
            margin-bottom: 1rem;
            padding: 0.75rem;
            max-width: 85%;
        }
        .delegation-header {
            display: flex; align-items: center; gap: 0.5rem;
            font-weight: 600; color: var(--bs-primary);
            margin-bottom: 0.5rem;
            font-size: var(--ab-text-base);
        }
        .delegation-content {
            font-size: var(--ab-text-base);
            color: var(--bs-body-color);
            padding-left: 1.5rem;
            border-left: 1px solid var(--bs-border-color-translucent);
        }
    `;

    constructor(config) {
        super(config);
        this.targetAgent = config.targetAgent;
        this.prompt = config.prompt;
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'delegation-card';
            this.container.innerHTML = `
                <div class="delegation-header">
                    <i class="bi bi-person-workspace"></i>
                    <span>Delegated to: ${this.escapeHtml(this.targetAgent)}</span>
                </div>
                <div class="delegation-content">
                    <div class="text-muted small mb-1">Instruction:</div>
                    <div>${this.escapeHtml(this.prompt)}</div>
                    <div class="mt-2 text-muted small fst-italic" id="delegation-status">Waiting for response...</div>
                </div>
            `;
        }
        return this.container;
    }

    updateStatus(status, result) {
        const statusEl = this.container.querySelector('#delegation-status');
        if (status === 'complete') {
            statusEl.className = 'mt-2 p-2 bg-light rounded';
            statusEl.innerHTML = `<strong>Response:</strong> ${this.escapeHtml(result)}`;
        } else if (status === 'fail') {
            statusEl.className = 'mt-2 text-danger';
            statusEl.textContent = `Delegation Failed: ${result}`;
        }
    }
}